import React, { Component, createRef } from 'react'
import './SkipButton.scss'

/*
const SkipButton = ({isDisabled, dispatchClick, step_id}) => {

    return (
      <button
        disabled={isDisabled}
        className="btn-skip"
        onClick={event => {
          event.preventDefault()
          dispatchClick(step_id)
        }}
      >
        Skip this Step
      </button>
    )
  }
*/

// We need to ensure that double-clicks don't trigger our onclick twice - it messes up analytics
class SkipButton extends Component {
  constructor(props) {
    super(props)

    this.myRef = createRef()

    this.handleClick = this.handleClick.bind(this)
  }

  handleClick = event => {
    event.preventDefault()

    if (this.myRef.current) {
      this.myRef.current.setAttribute('disabled', 'disabled')
    }

    // this.props.onClick && this.props.onClick(this.props.step_id)
    this.props.onClick()
  }

  render() {
    return (
      <div className="skip-button-will-appear-here">
        {!this.props.isDisabled && (
          <div className={`skip-button-container`}>
            <button
              ref={this.myRef}
              className="btn-skip"
              onClick={this.handleClick}
              aria-label="Skip this Activity"
            >
              Skip This Activity
            </button>
          </div>
        )}
      </div>
    )
  }
}

export default SkipButton
